/**
 * Generate insecure random ID.
 */
export const getRandomId = () => {
  return Date.now().toString(36) + Math.random().toString(36).slice(2);
};
